/* eslint-disable camelcase */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Spin,
  Icon,
} from 'antd';
import { getResourceCSV } from 'ACTIONS/resources.actions';
import { getTaskResourceById } from '../../helpers/resources';
import { store } from '../../App';

class ExportCSV extends Component {
  state = {
    isCSVLoading: false,
  };

  downloadCSV = async () => {
    const { resourceTypeId } = this.props;

    // For some reason this can be a string, and getTaskResourceById is strict
    const typeId = parseInt(resourceTypeId, 10);

    // We need to get the params state variable for our CSV query
    const state = store.getState();
    const resourceType = getTaskResourceById(typeId).pop();
    const resourceState = state.resources[resourceType];
    const { params } = resourceState;

    store.dispatch(getResourceCSV(resourceType, resourceTypeId, params));
  };

  handleExportClick = () => {
    this.setState({
      isCSVLoading: true,
    }, () => {
      setTimeout(async () => {
        await this.downloadCSV();
        this.setState({
          isCSVLoading: false,
        });
      }, 2000);
    });
  };

  render() {
    const { isCSVLoading } = this.state;
    const loadingIcon = <Icon type="loading" style={{ fontSize: 24 }} />;
    return (
      <Spin
        spinning={isCSVLoading}
        indicator={loadingIcon}
      >
        <Button
          className="export-action"
          onClick={this.handleExportClick}
        >
          <Icon type="export" />
          Export CSV
        </Button>
      </Spin>
    );
  }
}

ExportCSV.propTypes = {
  resourceTypeId: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]).isRequired,
};

export default ExportCSV;



// WEBPACK FOOTER //
// ./src/components/ExportCSV/ExportCSV.js